import { Button } from '../../Atoms/Button';
import { If } from '../../Atoms/Conditionals';
import { rewardList } from './rewards_category';
import { RewardsCardWrapper } from './styles';

export const IndividiualsRewardCard = (
  cate: string,
  rewards: rewardList[]
): JSX.Element[] => {
  const filteredRewards = rewards.filter(
    (item: rewardList) => item.category === cate && item.rewardDescription
  );
  const hideFor = 243;
  const image =
    'https://assets.clear.in/cleartax/images/1756815166_emailbanner1.png';
  return filteredRewards.map((reward) => (
    <div
      className="w-1/3 py-2 sm:w-full"
      key={reward.id}
      data-testid="individual-reward"
    >
      <If condition={reward.id !== hideFor}>
        <RewardsCardWrapper
          className="flex bg-center bg-no-repeat h-52"
          backgroundImage={reward.backgroundUrl}
        >
          <div className="w-1/2 pl-6 flex justify-end pb-8 flex-col">
            <p className="text-s-12 pr-3 pl-1">
              {`${
                reward.rewardDescription
                  ?.replace(/\$/g, '\n')
                  ?.replace(/&amp;/g, '&') || ''
              }`}
            </p>
            <div>
              <Button className="px-3 py-2 my-1 bg-blue-350" id="menu-button">
                <a
                  href="/income-tax-efiling"
                  rel="noreferrer"
                  className="text-white text-s-14"
                >
                  Claim rewards
                </a>
              </Button>
            </div>
          </div>
        </RewardsCardWrapper>
      </If>
      <If condition={reward.id === hideFor}>
        <a href="https://www.kotaksecurities.com/landing-page/fintech-partnership/cleartax-demat-account/">
          <img src={image} alt="Kotak-Bank-Banner" />
        </a>
      </If>
    </div>
  ));
};
